import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { CHECKING_BANNER_VARIANT } from '@banking/ui/utils/constants';
const getCountryCodeBasedImageUrl = urlCallback => countryCode => {
  switch (Country[countryCode]) {
    case Country.US:
    case Country.CA:
    case Country.GB:
      return urlCallback(countryCode);
    default:
      throw new Error(`Unsupported country code: ${countryCode}`);
  }
};
export const getCheckingUpsellImage = (countryCode, variant) => getCountryCodeBasedImageUrl(countryCode => {
  switch (variant) {
    case CHECKING_BANNER_VARIANT.MEDIUM:
      return `@banking/ui/assets/images/checking/upsell/card-en-${countryCode}.png`;
    case CHECKING_BANNER_VARIANT.LARGE:
      return `@banking/ui/assets/images/checking/upsell/full-card-en-${countryCode}.png`;
  }
})(countryCode);
export const getOnboardingHeroImageUrl = getCountryCodeBasedImageUrl(countryCode => `@banking/ui/assets/images/checking/onboarding/hero-en-${countryCode}.png`);
export const getOnboardingUpsellImageUrl = getCountryCodeBasedImageUrl(countryCode => `@banking/ui/assets/images/checking/checking-onboarding-en-${countryCode}.png`);